import { TSignInParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const signIn = async (params: TSignInParams) => {
  const { email, password } = params;

  await m8API.auth.signin({ email, password });
};
